import React from "react";
import { StyleSheet, View } from "react-native";
import { useNavigate } from "react-router-dom";

import { SecondaryButton } from "../../common/native";
import { ADMIN_TOKENS } from "../../../styles/adminTokens";

type TAdminDashboardTab = "activity" | "analytics" | "newUsers";

const TOKENS = ADMIN_TOKENS;

const ADMIN_DASHBOARD_TABS: {
  key: TAdminDashboardTab;
  label: string;
  route: string;
}[] = [
  {
    key: "activity",
    label: "Activity Stream",
    route: "/admin-activity-stream",
  },
  { key: "analytics", label: "Admin Analytics", route: "/admin-analytics" },
  { key: "newUsers", label: "New Users", route: "/admin-new-users" },
];

const AdminAnalyticsTabs: React.FC<{
  activeTab: TAdminDashboardTab;
}> = ({ activeTab }) => {
  const navigate = useNavigate();

  return (
    <View style={styles.tabRow}>
      {ADMIN_DASHBOARD_TABS.map((tab) => (
        <SecondaryButton
          key={tab.key}
          text={tab.label}
          selected={activeTab === tab.key}
          onPress={() => {
            if (activeTab !== tab.key) {
              navigate(tab.route);
            }
          }}
          style={styles.tabButton}
        />
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  tabRow: {
    flexDirection: "row",
    gap: TOKENS.spacing.sm,
    flexWrap: "wrap",
  },
  tabButton: {
    minWidth: TOKENS.size.authButtonMinWidth,
  },
});

export default AdminAnalyticsTabs;
